import React from 'react';
import { LuHeart } from 'react-icons/lu';

const Footer = () => {
  return (
    <footer className="bg-white border-t border-gray-200 py-4">
      <div className="max-w-7xl mx-auto px-4 grid grid-cols-1 sm:grid-cols-3 items-center justify-between gap-4">
        <p className="text-sm text-center md:text-left text-gray-600">
          © {new Date().getFullYear()} CrikStars. All rights reserved.
        </p>
        <div className="flex items-center gap-1 justify-center">
          <span className="text-sm text-gray-600">Made with</span>
          <LuHeart className="w-4 h-4 text-primary-600" />
          <span className="text-sm text-gray-600">by QuadRise Solutions LLP</span>
        </div>
        <div className="flex items-center gap-1 justify-center md:justify-end">
          <span className='text-gray-600 text-sm'>Version: </span><span className='text-gray-600 text-sm'>0.0.1</span>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
